module.exports = __webpack_public_path__ + "img/logo.823ba98d.png";